var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{attrs:{"continuous":"","cycle":"","height":"100vh","hide-delimiter-background":"","hide-delimiters":"","show-arrows":false,"show-indicators":false}},_vm._l((_vm.images),function(image,idx){return _c('v-carousel-item',{key:idx},[_c('v-img',{attrs:{"src":image,"height":"100%","width":"100%"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }